import styled from 'styled-components';

export const ScrollBarStyle = `
  scrollbar-base-color: #9c9595;
  scrollbar-3dlight-color: #9c9595;
  scrollbar-highlight-color: #9c9595;
  scrollbar-track-color: #555;
  scrollbar-arrow-color: #ccc;
  scrollbar-shadow-color: #9c9595;
  scrollbar-dark-shadow-color: #9c9595;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-button {
    background: transparent;
  }

  &::-webkit-scrollbar-track {
    background: #fff;
  }

  &::-webkit-scrollbar-track-piece {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    background: #9c9595;
  }
`;

const StyledScrollBars = styled.div`
  ${ScrollBarStyle}
`;

export default StyledScrollBars;
